import service from '@/utils/request'
// 查询登陆日志记录
export function userLoginLogList(param) {
    return service.request({
        method: 'post',
        url: '/app/userLoginLog/userLoginLogList',
        data: param
    })
}
// 新增登陆日志记录
export function addUserLoginLog(param) {
    return service.request({
        method: 'post',
        url: '/app/userLoginLog/add',
        data: param
    })
}
// 修改登陆日志记录
export function editUserLoginLog(param) {
    return service.request({
        method: 'post',
        url: '/app/userLoginLog/edit',
        data: param
    })
}
// 删除登陆日志记录
export function delUserLoginLog(param) {
    return service.request({
        method: 'post',
        url: '/app/userLoginLog/del',
        data: param
    })
}
// 导出登陆日志记录
export function exportUserLoginLog(param) {
    return service.request({
        method: 'post',
        url: '/app/userLoginLog/export',
        data: param
    })
}

// 清空日志记录
export function clearUserLoginLog(param) {
	return service.request({
		method: 'post',
		url: '/app/userLoginLog/clear',
		data: param
	})
}
